import { MyTicketsPage as PlatformMyTicketsPage } from '@jarvis/platform-ui';
import { useSearchParams } from 'react-router';
import { useAuthStore } from '../../auth/useAuthStore';
import { siteFeedbackApi } from '../../siteSupport/config';

export function MyTicketsPage() {
  const username = useAuthStore((s) => s.username) ?? 'unknown';
  const displayName = useAuthStore((s) => s.displayName) ?? undefined;
  const [params] = useSearchParams();
  const tabParam = params.get('tab');
  const initialTab = tabParam === 'feedback' ? 'feedback' : 'bugs';
  const initialId = params.get('id');

  return (
    <PlatformMyTicketsPage
      api={siteFeedbackApi}
      currentUserId={username}
      currentUserName={displayName}
      initialTab={initialTab}
      initialId={initialId}
    />
  );
}
